import {
  HTTP_GETFORECASTLIST5_FETCHING,
  HTTP_GETFORECASTLIST5_SUCCESS,
  HTTP_GETFORECASTLIST5_FAILED,
  HTTP_RESET_FORECASTLIST5,
} from "../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETFORECASTLIST5_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETFORECASTLIST5_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETFORECASTLIST5_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    case HTTP_RESET_FORECASTLIST5:
      return initialState;
    default:
      return state;
  }
};
